// extracted by mini-css-extract-plugin
module.exports = {"number_input":"InputNumber_number_input__3HLfp","plus":"InputNumber_plus__3C63V","minus":"InputNumber_minus__1zZd7"};